import I18n from 'I18n';
import { useRef, useState } from 'react';
import styled from 'styled-components';
import VizExIcon from 'visitor-ui-component-library/icon/VizExIcon';
import SVGExpand from 'visitor-ui-component-library-icons/icons/SVGExpand';
import SVGPlay from 'visitor-ui-component-library-icons/icons/SVGPlay';
import MediaCaption from './MediaCaption';
import MediaWrapper from './MediaWrapper';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ExpandButton = styled.button.withConfig({
  displayName: "VideoCard__ExpandButton"
})(["position:absolute;top:", ";right:", ";background:rgba(0,0,0,0.5);border:none;border-radius:", ";width:28px;height:28px;cursor:pointer;display:flex;align-items:center;justify-content:center;padding:0;color:", ";opacity:0;transition:opacity 150ms ease;"], ({
  theme
}) => theme.spotlight.spacing.sm, ({
  theme
}) => theme.spotlight.spacing.sm, ({
  theme
}) => theme.spotlight.borderRadius.pill, ({
  theme
}) => theme.spotlight.color.surface);
const PlayButtonOverlay = styled.div.withConfig({
  displayName: "VideoCard__PlayButtonOverlay"
})(["position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);width:48px;height:48px;border-radius:", ";background:rgba(0,0,0,0.35);display:flex;align-items:center;justify-content:center;pointer-events:none;transition:background 150ms ease;"], ({
  theme
}) => theme.spotlight.borderRadius.pill);
const VideoWrapper = styled(MediaWrapper).withConfig({
  displayName: "VideoCard__VideoWrapper"
})(["cursor:", ";max-width:360px;&:hover ", "{background:", ";}&:hover ", "{opacity:1;}"], ({
  $clickable
}) => $clickable ? 'pointer' : 'default', PlayButtonOverlay, ({
  theme
}) => theme.spotlight.color.orange, ExpandButton);
const StyledVideo = styled.video.withConfig({
  displayName: "VideoCard__StyledVideo"
})(["width:100%;display:block;border-radius:", ";"], ({
  theme
}) => theme.spotlight.borderRadius.sm);
const StyledPlayIcon = styled(VizExIcon).withConfig({
  displayName: "VideoCard__StyledPlayIcon"
})(["color:", ";margin-left:3px;"], ({
  theme
}) => theme.spotlight.color.surface);
const VideoCard = ({
  fileMetadata,
  thumbnailMetadata
}) => {
  const [isPlaying, setIsPlaying] = useState(false);
  const videoRef = useRef(null);
  const {
    url,
    // TODO: replace with real title when backend adds title field
    displayName: title
  } = fileMetadata;
  const posterUrl = thumbnailMetadata ? thumbnailMetadata.url : undefined;
  const handlePlay = () => {
    var _videoRef$current;
    setIsPlaying(true);
    (_videoRef$current = videoRef.current) === null || _videoRef$current === void 0 || _videoRef$current.play().catch(() => {
      // browser may block autoplay — user can interact with native controls
    });
  };
  const handleExpand = e => {
    var _videoRef$current2;
    e.stopPropagation();
    void ((_videoRef$current2 = videoRef.current) === null || _videoRef$current2 === void 0 ? void 0 : _videoRef$current2.requestFullscreen());
  };
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsxs(VideoWrapper, {
      $clickable: !isPlaying,
      onClick: !isPlaying ? handlePlay : undefined,
      children: [/*#__PURE__*/_jsx(StyledVideo, {
        ref: videoRef,
        src: url,
        poster: posterUrl,
        preload: posterUrl ? 'none' : 'metadata',
        controls: isPlaying,
        muted: !isPlaying,
        "aria-label": title
      }), !isPlaying && /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(PlayButtonOverlay, {
          children: /*#__PURE__*/_jsx(StyledPlayIcon, {
            icon: /*#__PURE__*/_jsx(SVGPlay, {}),
            size: "xs"
          })
        }), /*#__PURE__*/_jsx(ExpandButton, {
          type: "button",
          onClick: handleExpand,
          "aria-label": I18n.text('conversations-visitor-ui.spotlight.mediaCard.expandVideo'),
          children: /*#__PURE__*/_jsx(VizExIcon, {
            icon: /*#__PURE__*/_jsx(SVGExpand, {}),
            size: "xs"
          })
        })]
      })]
    }), /*#__PURE__*/_jsx(MediaCaption, {
      children: `0:00 · ${title}`
    })]
  });
};
VideoCard.displayName = 'VideoCard';
export default VideoCard;